import { msalConfig } from '@/authConfig'
import { acknowledgementReducer } from '@/reducers/acknowledgementReducers'
import addERPProductReducer from '@/reducers/addERPProductReducers'
import { consignmentOptionsReducer } from '@/reducers/consignmentReducers'
import {
  dashboardQuickOrderCloneReducer,
  dashboardQuickOrderCreateQuoteReducer,
  dashboardQuickOrderFavQuotesReducer,
  dashboardQuickOrderHeaderReducer,
  dashboardQuickOrderLineItemsReducer,
  dashboardQuickOrderRecentOrdersReducer
} from '@/reducers/dashboardQuickOrderReducers'
import {
  emailIngestionConfigCreateReducer,
  emailIngestionConfigUpdateReducer,
  emailIngestionConfigsReducer,
  emailIngestionRuleCreateReducer,
  emailIngestionRuleDeleteReducer,
  emailIngestionRuleUpdateReducer,
  emailIngestionRulesReducer,
  emailIngestionSetupReducer,
  emailProcessingStatusReducer,
  emailSubscriptionCreateReducer,
  emailSubscriptionUpdateReducer,
  emailSubscriptionsReducer,
  mailboxFoldersReducer
} from '@/reducers/emailSettingsReducers'
import { emailTemplatesReducer } from '@/reducers/emailTemplateReducers'
import {
  LinePriceReducer,
  QuoteInputsReducer,
  UpgradesReducer,
  addAcronymsReducer,
  addLineItemsFromUploadReducer,
  adminUserListReducer,
  altShipToAddressDeleteReducer,
  altShipToAddressReducer,
  approveOrderReducer,
  availablitiesreducer,
  branchListReducer,
  bulkApproveQuoteReducer,
  bulkDeleteQuoteReducer,
  clearUserBranchAvailabilityReducer,
  createQuotationReducer,
  createQuoteReducer,
  customerPartNumbersReducer,
  customerShippingDetailsReducer,
  deleteLinesReducer,
  deleteOrderReducer,
  detailedReplyReducer,
  distributorListReducer,
  distributorReducer,
  emailConversationListReducer,
  emailConversationReducer,
  emailSignatureReducer,
  emailSuggestionsReducer,
  emailTemplateReducer,
  erroredLineItemPatchReducer,
  erroredLineItemsReducer,
  existingOrderDetailsReducer,
  favoriteQuoteTableDataReducer,
  generateQuotePDFReducer,
  generateQuoteReducer,
  getAttachmentFilesReducer,
  getAvailabilitiesByPidsReducer,
  getCustomerDetailsListReducer,
  getExpandRowDetailsReducer,
  getLastQuotedPriceReducer,
  getNextAndPreviousQuotesReducer,
  getOrderListReducer,
  getOrderListTotalDetailsReducer,
  getOrderNumberListGlobalReducer,
  getQuoteListReducer,
  getQuoteTableReducer,
  getRecommendationsReducer,
  getSuggestionsListReducer,
  lineItemHighlightCoordinatesReducer,
  lineItemUpdatePendingReducer,
  lineItemWireCutReducer,
  lineItemsasyncreducer,
  linesuggestionReducer,
  lockQuoteReducer,
  logicAppStatusReducer,
  manageAllLineItemsReducer,
  matchStatusReducer,
  messageListReducer,
  multiBranchAvailabilityReducer,
  onboardingBranchesReducer,
  orderDetailsReducer,
  orderNumbersReducer,
  previewQuoteReducer,
  priceMarginBatchReducer,
  priceMarginReducer,
  quickOrderLineItemsReducer,
  quickReplyReducer,
  reSourcingReducer,
  refreshCostReducer,
  refreshLineItemReducer,
  salespersonSignatureTemplateReducer,
  selectOrderNumberReducer,
  sendToPunchOutReducer,
  sourceSuppliersReducer,
  totalOrderReducer,
  trendGraphReducer,
  updateEmailSignatureReducer,
  updateEmailTemplateReducer,
  updateFeedbackOfLineReducer,
  updateLineItemExtrasReducer,
  updateLineNumberReducer,
  updatePDFKeyValueReducer,
  updatePriceAfterUomReducer,
  updatePriceOfLineReducer,
  updateProductOfLineReducer,
  updateQouteMoreDetailsReducer,
  updateQuantityOfLineReducer,
  updateQuoteNotesReducer,
  updateRecommendationsOfLineReducer,
  updateShipToAddressReducer,
  updateSupplierReducer,
  updateUserBranchAvailabilityReducer,
  updatepricereducer
} from '@/reducers/orderReducers'
import { relatedDocumentReducer } from '@/reducers/RelatedDocumentReducer'
import { salespersonDetailsReducer, salespersonUpdateReducer } from '@/reducers/salespersonReducers'
import {
  shipmentManagerGroupedReducer,
  shipmentManagerPlanningReducer,
  shipmentManagerSplitReducer
} from '@/reducers/shipmentManagerReducers'
import { shipmentDetailsReducer, shipmentListReducer, shipmentResourcesReducer } from '@/reducers/shipmentReducers'
import {
  AddBoxReducer,
  UiRulesReducer,
  fileTypeReducer,
  pendingQuoteAttachmentReducer,
  selectAttachmentInfoStateReducer,
  selectDropdownStateReducer,
  selectedDateReducer,
  selectedTabReducer,
  selectedorderTypeReducer,
  stateCountryDropdownListReducer,
  tabelDropdownStateReducer,
  toggleSidebarReducer,
  uiReducer
} from '@/reducers/uiReducers'
import { repriceProgressReducer } from '@/reducers/repriceProgressReducer'
import { discontinuedLineCheckReducer } from '@/reducers/discontinuedLineCheckReducer'
import { uiSettingsReducer } from '@/reducers/uiSettingsReducer'
import { authenticatedUserReducer, userReducer } from '@/reducers/userReducers'
import { wireConfiguratorOptionsReducer, wireConfiguratorResolveReducer } from '@/reducers/wireConfiguratorReducers'
import { PublicClientApplication } from '@azure/msal-browser'
import { applyMiddleware, combineReducers, compose, createStore } from 'redux'
import { thunk } from 'redux-thunk'

const reducer = combineReducers({
  shipmentList: shipmentListReducer,
  shipmentDetails: shipmentDetailsReducer,
  shipmentResources: shipmentResourcesReducer,
  userDetails: userReducer,
  authenticatedUser: authenticatedUserReducer,
  orderDetails: orderDetailsReducer,
  update_price_margin: updatepricereducer,
  lineItemsasync: lineItemsasyncreducer,
  QuoteInputs: QuoteInputsReducer,
  orderNumbers: orderNumbersReducer,
  updateQuantityOfLine: updateQuantityOfLineReducer,
  updatePriceOfLine: updatePriceOfLineReducer,
  updateProductOfLine: updateProductOfLineReducer,
  suggestionsList: getSuggestionsListReducer,
  recommendationsList: getRecommendationsReducer,
  updateRecommendationsList: updateRecommendationsOfLineReducer,
  updateFeedbackOfLine: updateFeedbackOfLineReducer,
  approveOrder: approveOrderReducer,
  deleteLines: deleteLinesReducer,
  deleteOrder: deleteOrderReducer,
  addLineItemsFromUpload: addLineItemsFromUploadReducer,
  selectOrderNumber: selectOrderNumberReducer,
  updateShipToAddress: updateShipToAddressReducer,
  altShipToAddress: altShipToAddressReducer,
  altShipToAddressDelete: altShipToAddressDeleteReducer,
  AddBox: AddBoxReducer,
  tabelDropdownState: tabelDropdownStateReducer,
  selectDropdownState: selectDropdownStateReducer,
  getAttachmentFileUrls: getAttachmentFilesReducer,
  selectedTab: selectedTabReducer,
  selectAttachmentInfoState: selectAttachmentInfoStateReducer,
  existingOrderDetails: existingOrderDetailsReducer,
  getOrderListTotalDetails: getOrderListTotalDetailsReducer,
  getOrderList: getOrderListReducer,
  updateQouteMoreDetails: updateQouteMoreDetailsReducer,
  selectedDate: selectedDateReducer,
  selectedorderType: selectedorderTypeReducer,
  getOrderNumberListGlobal: getOrderNumberListGlobalReducer,
  getCustomerDetailsList: getCustomerDetailsListReducer,
  createQuote: createQuoteReducer,
  updateLineNumber: updateLineNumberReducer,
  updateLineItemExtras: updateLineItemExtrasReducer,
  addAcronyms: addAcronymsReducer,
  updateSupplier: updateSupplierReducer,
  updatePDFKeyValue: updatePDFKeyValueReducer,
  getExpandRowDetails: getExpandRowDetailsReducer,
  updateQuoteNotes: updateQuoteNotesReducer,
  getQuoteTable: getQuoteTableReducer,
  trendGraph: trendGraphReducer,
  getQuoteList: getQuoteListReducer,
  getAvailabilitiesByPids: getAvailabilitiesByPidsReducer,
  getNextAndPreviousQuotes: getNextAndPreviousQuotesReducer,
  quickOrderLineItems: quickOrderLineItemsReducer,
  reSourcing: reSourcingReducer,
  customerShippingDetails: customerShippingDetailsReducer,
  adminUserList: adminUserListReducer,
  branchList: branchListReducer,
  distributorList: distributorListReducer,
  messageList: messageListReducer,
  stateCountryDropdownList: stateCountryDropdownListReducer,
  toggleSidebar: toggleSidebarReducer,
  getLastQuotedPrice: getLastQuotedPriceReducer,
  bulkDeleteQuote: bulkDeleteQuoteReducer,
  bulkApproveQuote: bulkApproveQuoteReducer,
  updateOrderLineItemsWithAvailabilities: availablitiesreducer,
  ui: uiReducer,
  onboardingBranches: onboardingBranchesReducer,
  distributors: distributorReducer,
  getUiRules: UiRulesReducer,
  lineItemWireCut: lineItemWireCutReducer,
  customerPartNumbers: customerPartNumbersReducer,
  favoriteQuoteTableData: favoriteQuoteTableDataReducer,
  PriceAndMarginData: priceMarginReducer,
  priceMarginBatch: priceMarginBatchReducer,
  addUpgradesItems: UpgradesReducer,
  optimizedsuggestions: linesuggestionReducer,
  erroredLineItems: erroredLineItemsReducer,
  erroredLineItemPatch: erroredLineItemPatchReducer,
  emailConversationList: emailConversationListReducer,
  emailConversation: emailConversationReducer,
  quickReply: quickReplyReducer,
  detailedReply: detailedReplyReducer,
  emailSignature: emailSignatureReducer,
  emailSuggestions: emailSuggestionsReducer,
  emailTemplate: emailTemplateReducer,
  updateEmailSignature: updateEmailSignatureReducer,
  updateEmailTemplate: updateEmailTemplateReducer,
  salespersonSignatureTemplate: salespersonSignatureTemplateReducer,
  generateQuote: generateQuoteReducer,
  generateQuotePDF: generateQuotePDFReducer,
  sendToPunchOut: sendToPunchOutReducer,
  refreshCost: refreshCostReducer,
  createQuotation: createQuotationReducer,
  lockQuote: lockQuoteReducer,
  matchStatus: matchStatusReducer,
  previewQuote: previewQuoteReducer,
  pendingQuoteAttachment: pendingQuoteAttachmentReducer,
  updateselectedlinepricing: LinePriceReducer,
  uiSettings: uiSettingsReducer,
  emailTemplates: emailTemplatesReducer,
  salespersonDetails: salespersonDetailsReducer,
  salespersonUpdate: salespersonUpdateReducer,
  logicAppStatusData: logicAppStatusReducer,
  updateUserBranchAvailability: updateUserBranchAvailabilityReducer,
  clearUserBranchAvailability: clearUserBranchAvailabilityReducer,
  consignmentOptions: consignmentOptionsReducer,
  lineItemHighlightCoordinates: lineItemHighlightCoordinatesReducer,
  relatedDocument: relatedDocumentReducer,
  acknowledgement: acknowledgementReducer,
  manageAllLineItems: manageAllLineItemsReducer,
  search: addERPProductReducer,
  totalOrder: totalOrderReducer,
  highlightFileType: fileTypeReducer,
  lineItemUpdatePending: lineItemUpdatePendingReducer,
  multiBranchAvailability: multiBranchAvailabilityReducer,
  shipmentManagerPlanning: shipmentManagerPlanningReducer,
  shipmentManagerSplit: shipmentManagerSplitReducer,
  shipmentManagerGrouped: shipmentManagerGroupedReducer,
  dashboardQuickOrder: dashboardQuickOrderCreateQuoteReducer,
  dashboardQuickOrderHeader: dashboardQuickOrderHeaderReducer,
  dashboardQuickOrderLineItems: dashboardQuickOrderLineItemsReducer,
  dashboardQuickOrderRecentOrders: dashboardQuickOrderRecentOrdersReducer,
  dashboardQuickOrderFavQuotes: dashboardQuickOrderFavQuotesReducer,
  dashboardQuickOrderClone: dashboardQuickOrderCloneReducer,
  wireConfiguratorOptions: wireConfiguratorOptionsReducer,
  wireConfiguratorResolve: wireConfiguratorResolveReducer,
  updatePriceAfterUom: updatePriceAfterUomReducer,
  emailIngestionConfigs: emailIngestionConfigsReducer,
  emailIngestionConfigCreate: emailIngestionConfigCreateReducer,
  emailIngestionConfigUpdate: emailIngestionConfigUpdateReducer,
  emailIngestionRules: emailIngestionRulesReducer,
  emailIngestionRuleCreate: emailIngestionRuleCreateReducer,
  emailIngestionRuleUpdate: emailIngestionRuleUpdateReducer,
  emailIngestionRuleDelete: emailIngestionRuleDeleteReducer,
  emailSubscriptions: emailSubscriptionsReducer,
  emailSubscriptionCreate: emailSubscriptionCreateReducer,
  emailSubscriptionUpdate: emailSubscriptionUpdateReducer,
  emailIngestionSetup: emailIngestionSetupReducer,
  emailProcessingStatus: emailProcessingStatusReducer,
  mailboxFolders: mailboxFoldersReducer,
  sourceSuppliers: sourceSuppliersReducer,
  refreshLineItem: refreshLineItemReducer,
  repriceProgress: repriceProgressReducer,
  discontinuedLineCheck: discontinuedLineCheckReducer
})

// const setInitData = () => {
//   const initialData = {}

//   let valid = false
//   let clientInfo = {}
//   if (localStorage) {
//     const keys = Object.keys(localStorage)
//     keys.forEach((propName) => {
//       try {
//         if (localStorage.getItem(propName)) {
//           const propVal = JSON.parse(localStorage.getItem(propName))
//           if (propVal.clientId === msalConfig.auth.clientId) valid = true
//         }
//       } catch (error) {
//         // console.log(propName, error.message);
//       }
//     })

//     keys.forEach((propName) => {
//       try {
//         if (localStorage.getItem(propName)) {
//           const propVal = JSON.parse(localStorage.getItem(propName))
//           if (valid && propVal.hasOwnProperty('clientInfo')) clientInfo = propVal
//         }
//       } catch (error) {
//         // console.log(error.message);
//       }
//     })
//   }

//   initialData.userDetails = clientInfo
//   return initialData
// }

// const initialState = setInitData()

const middleware = [thunk]
const composeEnhancers =
  import.meta.env.DEV && typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose

const store = createStore(reducer, {}, composeEnhancers(applyMiddleware(...middleware)))

export default store

export const msalInstance = new PublicClientApplication(msalConfig)
